// Pricing section — "Compare all features" toggle. Slides the hidden
// .pricing-compare panel open/closed and swaps the toggle label.

export default function initPricingCompare() {
  document.querySelectorAll('.section-pricing').forEach((section) => {
    const toggle = section.querySelector('.section-pricing__compare-toggle');
    const panel = section.querySelector('.pricing-compare');
    if (!toggle || !panel) return;

    const openLabel = toggle.textContent.trim();
    const closeLabel = openLabel.replace('↓', '↑').replace(/^Compare/i, 'Hide');

    toggle.setAttribute('role', 'button');
    toggle.setAttribute('tabindex', '0');
    toggle.setAttribute('aria-expanded', 'false');

    function toggleOpen() {
      const isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.textContent = isOpen ? closeLabel : openLabel;

      if (!isOpen) {
        // Bring the packages back into view when collapsing a tall table.
        section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    toggle.addEventListener('click', toggleOpen);
    toggle.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleOpen();
      }
    });
  });
}
